const testimonials = [
  {
    name: "Todd R.",
    location: "Lake Charles Industrial Corridor, LA",
    rating: 5,
    text: "I work in process safety at a Lake Charles petrochemical plant and got assigned to a plant turnaround in Saudi Arabia with 13 days notice. Saudi Arabia requires six months passport validity and mine had four months left. I needed a renewal fast. Fast Passport Center got my renewal processed and delivered in six business days. Flew out of Houston Bush on schedule. These guys understand industrial travel timelines.",
    service: "Emergency Renewal",
  },
  {
    name: "Jessica M.",
    location: "Sulphur, LA",
    rating: 5,
    text: "My husband and I booked a last-minute Carnival cruise from Galveston and realized his passport had expired three months prior. I called Fast Passport Center on a Monday, they walked us through exactly what to ship, and his renewed passport arrived by Friday afternoon. We drove to Galveston Saturday morning and made the sailing. Absolutely the best service for a stressful situation.",
    service: "Emergency Renewal",
  },
  {
    name: "Kevin T.",
    location: "Lake Charles, LA",
    rating: 5,
    text: "I manage casino operations and got invited to an industry conference in Macau on three weeks notice. My passport was expired and I did not know how fast I could get it renewed. Fast Passport Center handled everything and I had my renewed passport in seven business days. Made the conference, made the connection through LAX. Worth every cent of the expedited fee compared to the cost of missing that trip.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LakeCharlesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Southwest Louisiana Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Lake Charles, Sulphur, and Southwest Louisiana travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}